import { IconBadge } from '../ui/IconBadge';
import React from 'react';
import { cn } from '../../lib/utils';
import {
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import {
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog';
import {
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '../ui/sheet';

/**
 * Cabeçalho padrão Office para pop-ups (ícone + título + subtítulo).
 * variant is retained for compatibility; both use the shared icon badge.
 * layout: stack (ícone acima) | row (ícone ao lado).
 * asAlert / asSheet: primitives de AlertDialog ou Sheet.
 */
export function OfficeModalHeader({
  icon: Icon,
  title,
  description,
  variant = 'circle',
  layout = 'row',
  asAlert = false,
  asSheet = false,
  className,
  titleClassName,
  children,
}) {
  let Header = DialogHeader;
  let Title = DialogTitle;
  let Description = DialogDescription;
  if (asAlert) {
    Header = AlertDialogHeader;
    Title = AlertDialogTitle;
    Description = AlertDialogDescription;
  } else if (asSheet) {
    Header = SheetHeader;
    Title = SheetTitle;
    Description = SheetDescription;
  }

  const iconEl = Icon ? <IconBadge icon={Icon} className={cn('office-modal-icon', variant === 'square' && 'office-modal-icon--square')} /> : null;

  if (layout === 'row') {
    return (
      <Header
        className={cn(
          'office-modal-header--row office-dialog-head space-y-0 text-left',
          className,
        )}
      >
        {iconEl}
        <div className="min-w-0 flex-1 space-y-1.5">
          <Title className={titleClassName}>{title}</Title>
          {description ? <Description>{description}</Description> : null}
          {children}
        </div>
      </Header>
    );
  }

  return (
    <Header className={cn('office-dialog-head space-y-2 text-left', className)}>
      {iconEl}
      <Title className={titleClassName}>{title}</Title>
      {description ? <Description>{description}</Description> : null}
      {children}
    </Header>
  );
}

export default OfficeModalHeader;
